"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageFieldView = exports.CSS = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../../components/theme");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    capture: 'c-Image__capture',
};
(0, theme_1.addStyles)({
    [exports.CSS.capture]: {
        padding: theme_1.DefaultTheme.space(1),
    },
});
exports.ImageFieldView = {
    viewInline(field) {
        const captures = field.getCaptures();
        if (captures.length > 0) {
            return String(captures.length);
        }
        return '';
    },
    hasDetail(field) {
        return field.getCaptures().length > 0;
    },
    viewDetail(field) {
        const ctx = { className: exports.CSS.capture };
        const collection = field.collection;
        const captureChildren = [];
        for (const capture of field.getCaptures()) {
            ctx.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            captureChildren.push(capture_thumbnail_1.CaptureThumbnail.view(collection, capture, ctx));
        }
        return mithril_1.m.fragment({}, captureChildren);
    },
    viewEdit(field, state) {
        return exports.ImageFieldView.viewInline(field, state);
    },
    hasClear(field) {
        return false;
    },
    canUpload(field) {
        const currentUser = services_1.Services.User.current;
        const userProfile = currentUser ? services_1.Services.UserProfile.get(currentUser.objectId) : null;
        const hasPreviousCaptures = core_shared_1.CaptureProviderHelpers.getCaptureIds(field.collection).length !== 0;
        return (hasPreviousCaptures &&
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_OFFICE_IMAGE_UPLOAD) &&
            services_1.Services.UserProfile.isOneOf(userProfile, [
                core_api_1.IkeUserRole.USER,
                core_api_1.IkeUserRole.EDITOR,
                core_api_1.IkeUserRole.ROOT,
                core_api_1.IkeUserRole.DATA_ADMIN,
            ]));
    },
};
//# sourceMappingURL=image.field.view.js.map